import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'icon-svg',
  template: `
    <span
      [innerHTML]="svgContent"
      [class]="className"
      [style.display]="'inline-block'"
      [style.width]="sizePx"
      [style.height]="sizePx"
    >
    </span>
  `,
})
export class IconSvgComponent implements OnInit {
  @Input() type = '';
  _size = 24;
  @Input()
  set size(size: number) {
    this._size = size;
    this.sizePx = `${size}px`;
  }
  get size(): number {
    return this._size;
  }
  @Input() strokeColor?: string;
  @Input() fillColor?: string;
  @Input() className?: string;

  sizePx = `${this.size}px`;

  svgContent: SafeHtml | null = null;
  iconUrl = '';

  constructor(
    private changeDetectionRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.iconUrl = `https://cdn.taclia.com/icons/svg/${this.type}.svg`;
    const isLinear = this.type.includes('linear/');

    const fill =
      this.fillColor || (isLinear ? 'transparent' : this.strokeColor);
    const stroke = this.strokeColor || (isLinear ? this.strokeColor : 'white');

    fetch(this.iconUrl)
      .then((res) => res.text())
      .then((content) => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(content, 'image/svg+xml');
        const svgElement = svgDoc.querySelector('svg');
        if (svgElement) {
          svgElement.setAttribute('width', this.sizePx);
          svgElement.setAttribute('height', this.sizePx);
          if (stroke && fill) {
            svgElement.setAttribute('stroke', stroke);
            svgElement.setAttribute('fill', fill);
            const paths = svgElement.querySelectorAll('path');
            paths.forEach((path) => {
              path.setAttribute('stroke', stroke);
              path.setAttribute('fill', fill);
              path.setAttribute('stroke-width', '1.5');
            });
          }
          this.svgContent = this.sanitizer.bypassSecurityTrustHtml(
            svgElement.outerHTML
          );
        }
      })
      .finally(() => {
        this.draw();
      })
      .catch(() => console.error(`Error loading icon: ${this.type}`));
  }

  private draw() {
    this.changeDetectionRef.detectChanges();
  }
}
